jQuery(function($){
    $('.faq-accordion').off('click.accordion').on('click.accordion', '.faq-header', function(){
        var $item    = $(this).closest('.faq-item');
        var $content = $item.children('.faq-content');

        if ( $item.hasClass('open') ) {
            $item.removeClass('open');
            $content.slideUp(200);
        } else {
            // close any open one
            $('.faq-item.open')
                .removeClass('open')
                .children('.faq-content')
                .slideUp(200);
            // open clicked
            $item.addClass('open');
            $content.slideDown(200);
        }
    });
});
